import * as React from "react";
import { Helmet } from "react-helmet";

interface Props {
  children?: React.ReactNode;
  content: string;
  title?: string;
}

const MetaDescription = ({ content, title, children }: Props) => (
  <Helmet>
    <meta content={content} id="meta-description" name="description" />
    <meta content={content} name="twitter:description" />
    <meta content={content} name="og:description" />
    {title ? <title>{title}</title> : null}
    {children}
  </Helmet>
);

export default MetaDescription;
